import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchFacebookAdsAccounts, fetchGraphFunnelLeakageFB } from "./FacebookAdsAPI";
import { readFromFBDB } from "../../../../services/fbdb.data";
import { use } from "react";
import { getDataFromMongoDb } from "../../../../services/mongod.data";

const initialState = {
  status: "idle",
  error: null,
  data: {},
  fbProfileInfo: {},
  accessToken: null,
  adsAccountStatus: "idle",
  adsAccountData: null,
  selectedAdsAccountId: null,
  selectedAd: null,
  selectedAdData:null
};

export const facebookAdDetailRetrieve = createAsyncThunk(
  "facebook/adDetails", async (query_data, { rejectWithValue }) => { 
    let { id, accessToken } = query_data;
    const fb_baseURL = "https://graph.facebook.com/v14.0/";
    let URL = `${fb_baseURL}${id}?fields=adcreatives{status,title,image_url,body,object_story_spec{link_data{caption}}}&access_token=${accessToken}`;
    console.log(`URL for Ad_ID ${id}`, URL);
    try {
      const response = await fetchFacebookAdsAccounts(URL);
      console.log("ads details data", response);
      return response;
    }catch (error) {
      return rejectWithValue(error);
    }
  }
)

export const graphFBAdsAccount = createAsyncThunk(
  "facebook/adsAccountsTemp",
  async (user, { rejectWithValue }) => {
    try {
      const dbpath = `${user}/graph-funnel-leakage/account_data`;
      const response = await readFromFBDB(dbpath, user, 'graph-funnel-leakage/account_data');
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const graphFBAdsClientAccount = createAsyncThunk(
  "facebook/adsClientAccountsTemp",
  async (statsObj, { rejectWithValue }) => {
    const { user, id } = statsObj;
    console.log("statsObj", statsObj)
    try {
      const dbpath = `${user}/graph-funnel-leakage/client_data`;
      const dbpathMongo = await getDataFromMongoDb(user, "graph-funnel-leakage");
      const response = dbpathMongo.data?.["client_data"] || {};
      console.log("response client data", response)
      // return response.data;
      return { id, data: response.data.data };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
// graph-funnel-leakage/account_data

// graph-funnel-leakage/client_data

export const facebookAdsDataPull = createAsyncThunk(
  "facebook/adsAccounts",
  async (query_data, { rejectWithValue }) => {
    let { id, breakdowns, start_date, end_date, accessToken } = query_data;
    const fb_baseURL = "https://graph.facebook.com/v14.0/";
    try {
      let query = `${id}/insights?level=ad&breakdowns=${breakdowns}&time_range[since]=${start_date}&time_range[until]=${end_date}&fields=campaign_id,campaign_name,adset_id,adset_name,ad_id,ad_name,spend,impressions,clicks,reach,frequency,cpm,cpc,ctr&limit=5000`;
      let URL = `${fb_baseURL}${query}&access_token=${accessToken}`;
      const response = await fetchFacebookAdsAccounts(URL);
      // console.log("ads account data", response);
      return { id, data: response.data };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


const facebookAdsSlice = createSlice({
  name: "facebook",
  initialState,
  reducers: {
    setFacebookProfileData: (state, action) => {
      const result = action.payload;
      state.data = result;
      try {
        state.fbProfileInfo["email"] = result?.email || "";
        state.fbProfileInfo["userID"] = result?.userID || "";
        state.fbProfileInfo["name"] = result?.name || "";
        state.fbProfileInfo["profile_pic"] = result?.picture?.data?.url || "";
        state.accessToken = result?.accessToken;
        state.fbProfileInfo["ads_accounts"] = getAdsAccounts(
          result?.adaccounts?.data
        );
      } catch (error) {
        console.log("error occurred during setting fb profile data", error);
      }
    },
    resetSelectedAd: (state, action) => {
      state.selectedAd = null;
      state.selectedAdData = null;
    },
    updateadsAccountData: (state, action) => {
      state.adsAccountData = action.payload
    },
    resetfacebookData: (state, action) => {
      return { ...initialState };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(facebookAdsDataPull.pending, (state) => {
        state.adsAccountStatus = "loading";
      })
      .addCase(facebookAdsDataPull.fulfilled, (state, action) => { 
        state.adsAccountStatus = "idle";
        let { id, data } = action.payload
        state.selectedAdsAccountId = id;
        state.adsAccountData = data;
      })
      .addCase(facebookAdsDataPull.rejected, (state, action) => { 
        state.adsAccountStatus = "error";
        state.error = action.payload?.error;
      })
      .addCase(facebookAdDetailRetrieve.pending, (state) => {
      })
      .addCase(facebookAdDetailRetrieve.fulfilled, (state, action) => { 
        let { id, adcreatives } = action.payload
        state.selectedAd = id;
        state.selectedAdData = adcreatives?.data?.[0];
      })
      .addCase(facebookAdDetailRetrieve.rejected, (state, action) => { 
        state.error = action.payload?.error;
      })
      .addCase(graphFBAdsAccount.fulfilled, (state, action) => { 
        const result = action.payload;
        state.data = result;
        try {
          state.fbProfileInfo["email"] = result?.email || "";
          state.fbProfileInfo["userID"] = result?.userID || "";
          state.fbProfileInfo["name"] = result?.name || "";
          state.fbProfileInfo["profile_pic"] = result?.picture?.data?.url || "";
          state.accessToken = result?.accessToken;
          state.fbProfileInfo["ads_accounts"] = getAdsAccounts(
            result?.adaccounts?.data
          );
        } catch (error) {
          console.log("error occurred during setting fb profile data", error);
        }
      })
      .addCase(graphFBAdsClientAccount.fulfilled, (state, action) => { 
        let { id, data } = action.payload
        console.log("id, data, debug", id, data)
        state.selectedAdsAccountId = id;
        state.adsAccountData = data;
      })
  },
});

export const { resetfacebookData,setFacebookProfileData, resetSelectedAd, updateadsAccountData } = facebookAdsSlice.actions;

export const SelectFBProfileData = (state) => state.facebook.fbProfileInfo;
export const SelectFBAccessToken = (state) => state.facebook.accessToken;
export const SelectFBAdsAccountData = (state) => state.facebook.adsAccountData;
export const SelectFBAdsActiveAccount = (state) => state.facebook.selectedAdsAccountId
export const selectedFBAdData = (state) => state.facebook.selectedAdData

function getAdsAccounts(adsdata) {
  let result = adsdata?.map(({ name, id }) => ({ name, id }));
  return result;
}

export default facebookAdsSlice.reducer;